import { useNavigate } from "react-router-dom";
import type { DirectorDataQualityCard } from "@/api/types";

/**
 * S5 — Data-quality section (separate from money risks, decision C). «Клієнти без
 * власника» is a DQ item, not a financial risk → kept out of Top-risks so the
 * severity-by-money list stays clean. «Переглянути» = link (read-only).
 */
export function DirectorDataQuality({ noOwner }: { noOwner: DirectorDataQualityCard }) {
  const navigate = useNavigate();
  return (
    <div className="rounded-2xl border border-border bg-card">
      <div className="flex items-center gap-3.5 px-4 py-3">
        <span className="h-2 w-2 flex-none rounded-full bg-[hsl(var(--info-foreground))]" />
        <div className="min-w-0 flex-1">
          <div className="text-[13.5px] font-semibold">Клієнти без власника</div>
          <div className="text-xs text-muted-foreground">
            <b className="font-semibold text-foreground">{noOwner.value}</b> Account з порожнім assignedUser — потребують
            перевірки у data-quality процесі
          </div>
        </div>
        <button
          type="button"
          onClick={() => navigate("/clients?dataQuality=no_owner")}
          className="flex-none text-[12.5px] font-semibold text-[hsl(var(--primary))] hover:underline"
        >
          Переглянути →
        </button>
      </div>
    </div>
  );
}
